import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import { users } from '../../../interfaces/users';
import { LanguageServiceService } from '../../../services/language-service.service';

import { Router } from '@angular/router';

import { UserService } from '../../../services/user';
import { DeviceDetectorService } from '../../../services/device-detector.service';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  userData!: users;
  classToggled: boolean = false;
  contentReady: boolean = true;
  userimage: string = '';
  userPhone: string = '';
  userName: string = '';
  userfirstname: string = '';
  userFacebook: string = '';
  userInstgram: string = '';
  userTiktok: string = '';
  id: string = '';
  hasItems: boolean = false;
  
  isMobile: boolean = false;
  isDeliveryHero: boolean = false;
  accountType!: string; // Default value, can be set based on your logic
  constructor(
    private _profileService: ProfileService,
    private _userService: UserService,
     private deviceService: DeviceDetectorService,
    private _router: Router
  ) { }
  ngOnInit(): void {
       this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isDeliveryHero = this.accountType == "8";
    

      },
      error: (error) => console.error(error),
    });
   this.userId();
  }
  getUserItems(id?: any) {
    this.isMobile = this.deviceService.isMobileDevice();
    this._profileService.getuserinfo(id).subscribe({
      next: (res) => {
        this.contentReady = true;
        this.userData = res;
        console.log(this.userData)
        this.userName = this.userData.username;
        this.userfirstname = this.userData.first_name;
        this.userFacebook = this.userData.facebook_link;
        this.userInstgram = this.userData.instagram_link;
        this.userTiktok = this.userData.tiktok_link;
        this.userPhone = this.userData.phone;
        this.userimage = this.changeUrl(this.userData.image);

        this.hasItems = false;
        this.contentReady = false;
      },
      error: (err) => this.contentReady = false
    });
    this.contentReady = true;
  }
changeUrl(url: string): string {
  return url.replace('/storage', '');
}
  userId(){
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.id = data['user_id'];
        this.getUserItems(this.id);
      },
      error: (error) => console.error(error),
    });

  }
}
